var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabMenuButton',_vm._g({attrs:{"show-status":_vm.showStatus,"status":_vm.status,"is-disabled":_vm.isDisabled || _vm.isLoadingDocument,"is-locked":_vm.isLocked,"active":_vm.active,"classes":_vm.classes,"disabled-reason":_vm.disabledReason,"link":_vm.link,"status-title":_vm.statusTitle}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }